var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenerating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 1,
    stroke: "#0070D2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.50009H25",
    stroke: "#0070D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3431 6.4822L13.3432 6.48212C13.6189 6.19897 13.6189 5.74843 13.3432 5.46527C13.0638 5.17843 12.6138 5.17843 12.3344 5.46527L7.91296 10.005L6.4656 8.51895C6.18623 8.2321 5.7362 8.2321 5.45683 8.51895C5.18106 8.8021 5.18106 9.25264 5.45683 9.5358L7.40393 11.535C7.68327 11.8218 8.13788 11.8218 8.41726 11.5351C8.41729 11.5351 8.41732 11.535 8.41734 11.535L13.3431 6.4822Z",
    fill: "#0070D2",
    stroke: "#0070D2",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.0001H25",
    stroke: "#0070D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40393 19.035L7.58302 18.8606L7.40393 19.035C7.68327 19.3218 8.13788 19.3218 8.41726 19.0351C8.41729 19.0351 8.41732 19.035 8.41734 19.035L13.3431 13.9822L13.3432 13.9821C13.6189 13.699 13.6189 13.2484 13.3432 12.9653C13.0638 12.6784 12.6138 12.6784 12.3344 12.9653L7.91296 17.505L6.4656 16.0189C6.18623 15.7321 5.7362 15.7321 5.45683 16.0189C5.18106 16.3021 5.18106 16.7526 5.45683 17.0358L7.40393 19.035Z",
    fill: "#0070D2",
    stroke: "#0070D2",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.5002H25",
    stroke: "#0070D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerating);
export default __webpack_public_path__ + "static/media/generating.74b666d4870822d4425717f8ceb5af4e.svg";
export { ForwardRef as ReactComponent };